import theme from "src/components/themes/DefaultTheme";
import styled from 'src/lib/styles/css';


//#region [Component]
export default function NFKFooter() {
    return (
        <SFooter >
            <div>
                <nav role="navigation"  >

                    <SLogos >
                        <SEgmontLogo>
                            <a href="http://www.egmont.com/">Egmont</a>
                        </SEgmontLogo>
                        <SECLogo>
                            <a href="https://www.europa-cinemas.org/en">Europe Cinemas</a>
                        </SECLogo>
                    </SLogos>
                </nav>
                <nav role="navigation"  >
                    <SBrand href="https://www.nfkino.no/">
                        <SBrandImage src="https://www.nfkino.no/themes/custom/nfbiono/logo.svg" alt="Home" />
                    </SBrand>
                </nav>
            </div>


        </SFooter>
    );
}
//#endregion

//#region [Styles]
const SFooter = styled.footer`
	background-color: #0e0e1b;
	color: white;

	ul {
		list-style-type: none;
		padding: 0;
	}
	a {
		color: white;
		text-decoration: none;
	}
`;

const SLogos = styled.ul`
	font-size: 16px;
	line-height: 1.5;
	color: #fff;
	font-family: sans-serif;
	box-sizing: border-box;
	padding: 0 20px;
	list-style: none;
	list-style-type: none;
	max-width: 1220px;
	margin: 0 auto;
	padding-top: 55px !important;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;

	a {
		background-size: contain;
		max-width: 100%;
	}
`;

const SEgmontLogo = styled.li`
	width: 48%;
	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        width: auto;
    }
    a {
        font-size: 16px;
        box-sizing: border-box;
        color: transparent;
        background-color: transparent;
        background-image: url("https:/*www.nfkino.no/themes/custom/nfbiono/assets/img/egmont-footer-logo.svg");*/
        width: 190px;
        height: 46px;

        display: block;
        background-size: 100%;
        background-repeat: no-repeat;
        margin: 0;
    }
`;

const SECLogo = styled.li`
	width: 48%;
	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        width: 245px;
    }

    a {
        box-sizing: border-box;
        background-color: transparent;
        color: transparent;
        display: block;
        background-size: 100%;
        background-repeat: no-repeat;
        background-image: url("https:/*www.nfkino.no/themes/custom/nfbiono/assets/img/europa-cinemas.png");*/
        width: 190px;
        height: 62px;
        margin: 0;
    }
`;

const SBrandImage = styled.img`
	height: 100px;
    margin: 1em auto;
    display: block;
`
const SBrand = styled.a`
	margin: 0 auto;
`;
//#endregion